"use strict";

var agendorAPI = require("app/util/api/agendor-api");

module.exports.getPostURL = function getPostURL(filename, cb) {
  agendorAPI.get("/attachment/post_url", {
    file_name: filename
  }, cb);
};

module.exports.post = function post(url, file, cb) {
  agendorAPI.post("/attachment/post_url", {
    file_name: filename
  }, cb);
};


// WEBPACK FOOTER //
// ./app/util/api/attachments.js